import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import instance from "../../../config/Config";

const initialState = {
    data: null,
    loading: false,
    error: null,
    count: null,
    response: null,
    companyList: null,
    jobList: null,
    candidateList: null
};

export const fetchCompanyList = createAsyncThunk(
    "fetchCompanyList",
    async (body) => {
        try {
            const response = await instance.get(
                `/remark/endtoend/ete-company-list?page=${body.page}&search=${body.search}&startDate=${body.startDate}&endDate=${body.endDate}`
            );
            return response.data;
        } catch (error) {
            throw error;
        }
    }
);

export const addCompanyList = createAsyncThunk(
    "addCompanyList",
    async (body) => {

        try {
            const res = await instance.post("/remark/endtoend/add-ete-company", body)
            return res?.data
        } catch (error) {
            throw error
        }
    }
)
export const updateCompanyList = createAsyncThunk(
    "updateCompanyList",
    async (data) => {

        try {
            const res = await instance.post(`/remark/endtoend/update-ete-company?id=${data.id}`, data?.data)
            return res?.data
        } catch (error) {
            throw error
        }
    }
)

export const fetchSingleCompanyList = createAsyncThunk("fetchSingleCompanyList", async (id) => {
    try {
        const response = await instance.get(`/remark/endtoend/ete-company-single?id=${id}`);
        return response?.data;
    } catch (error) {
        return error;
    }
})



export const fetchJobRequirement = createAsyncThunk(
    "fetchJobRequirement",
    async (body) => {
        try {
            const response = await instance.get(
                `/remark/endtoend/ete-job-requirement-list?page=${body.page}&search=${body.search}&startDate=${body.startDate}&endDate=${body.endDate}`
            );
            return response.data;
        } catch (error) {
            throw error;
        }
    }
);


export const addJobRequirement = createAsyncThunk(
    "addJobRequirement",
    async (body) => {

        try {
            const res = await instance.post("/remark/endtoend/create-job-requirement", body)
            return res?.data
        } catch (error) {
            throw error
        }
    }
)
export const updateJobRequirement = createAsyncThunk(
    "updateJobRequirement",
    async (data) => {

        try {
            const res = await instance.post(`/remark/endtoend/update-job-requirement?id=${data.id}`, data?.data)
            return res?.data
        } catch (error) {
            throw error
        }
    }
)

export const requirementStatusUpdate = createAsyncThunk(
    "requirementStatusUpdate",
    async (data) => {
        try {
            const response = await instance.post(`/remark/endtoend/update-job-requirement-status?id=${data?.ejr_id}&status=${data?.status}`)
            return response?.data

        } catch (error) {
            throw error;
        }
    }
);



export const fetchAllCandidateList = createAsyncThunk(
    "fetchAllCandidateList",
    async () => {

        try {
            const res = await instance.get("/remark/endtoend/endtoend-candidate-list")
            return res?.data
        } catch (error) {
            throw error
        }
    }
)

export const EndToEndHiringSlice = createSlice({
    name: "EndToEndHiringSlice",
    initialState,
    reducers: {},
    extraReducers: (builder) => {
        builder.addCase(fetchCompanyList.pending, (state, action) => {
            state.loading = true;
        });
        builder.addCase(fetchCompanyList.fulfilled, (state, action) => {
            state.loading = false;
            state.data = action.payload;
            state.count = action.payload?.count;
        });
        builder.addCase(fetchCompanyList.rejected, (state, action) => {
            state.loading = false;
            state.error = action.payload;
        });

        builder.addCase(addCompanyList.pending, (state, action) => {
            state.loading = true;
        });
        builder.addCase(addCompanyList.fulfilled, (state, action) => {
            state.loading = false;
            state.response = action.payload;
            state.count = action.payload?.count;
        });
        builder.addCase(addCompanyList.rejected, (state, action) => {
            state.loading = false;
            state.error = action.payload;
        });
        builder.addCase(updateCompanyList.pending, (state, action) => {
            state.loading = true;
        });
        builder.addCase(updateCompanyList.fulfilled, (state, action) => {
            state.loading = false;
            state.response = action.payload;
            state.count = action.payload?.count;
        });
        builder.addCase(updateCompanyList.rejected, (state, action) => {
            state.loading = false;
            state.error = action.payload;
        });

        builder.addCase(fetchSingleCompanyList.pending, (state, action) => {
            state.loading = true;
        });
        builder.addCase(fetchSingleCompanyList.fulfilled, (state, action) => {
            state.loading = false;
            state.companyList = action.payload;
            state.count = action.payload?.count;
        });
        builder.addCase(fetchSingleCompanyList.rejected, (state, action) => {
            state.loading = false;
            state.error = action.payload;
        });
        builder.addCase(fetchJobRequirement.pending, (state, action) => {
            state.loading = true;
        });
        builder.addCase(fetchJobRequirement.fulfilled, (state, action) => {
            state.loading = false;
            state.jobList = action.payload;
            state.count = action.payload?.count;
        });
        builder.addCase(fetchJobRequirement.rejected, (state, action) => {
            state.loading = false;
            state.error = action.payload;
        });

        builder.addCase(addJobRequirement.pending, (state, action) => {
            state.loading = true;
        });
        builder.addCase(addJobRequirement.fulfilled, (state, action) => {
            state.loading = false;
            state.response = action.payload;
            state.count = action.payload?.count;
        });
        builder.addCase(addJobRequirement.rejected, (state, action) => {
            state.loading = false;
            state.error = action.payload;
        });
        builder.addCase(updateJobRequirement.pending, (state, action) => {
            state.loading = true;
        });
        builder.addCase(updateJobRequirement.fulfilled, (state, action) => {
            state.loading = false;
            state.response = action.payload;
            state.count = action.payload?.count;
        });
        builder.addCase(updateJobRequirement.rejected, (state, action) => {
            state.loading = false;
            state.error = action.payload;
        });

        builder.addCase(requirementStatusUpdate.pending, (state, action) => {
            state.loading = true;
        });
        builder.addCase(requirementStatusUpdate.fulfilled, (state, action) => {
            state.loading = false;
            state.response = action.payload;
            state.count = action.payload?.count;
        });
        builder.addCase(requirementStatusUpdate.rejected, (state, action) => {
            state.loading = false;
            state.error = action.payload;
        });
        builder.addCase(fetchAllCandidateList.pending, (state, action) => {
            state.loading = true;
        });
        builder.addCase(fetchAllCandidateList.fulfilled, (state, action) => {
            state.loading = false;
            state.candidateList = action.payload;
            state.count = action.payload?.count;
        });
        builder.addCase(fetchAllCandidateList.rejected, (state, action) => {
            state.loading = false;
            state.error = action.payload;
        });
    },
});

export default EndToEndHiringSlice.reducer;
